// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #ffffff;
  display: flex;
  font-family: Manrope;
}

.navhead {
  background-color: #ffffff !important;
  box-shadow: #0000001a 0px 5px 7px -3px, #0000000d 0px 2px 3px -2px;
  width: 100%;
  min-height: 80px;
}

.navhead {
  .container-fluid {
    width: 90%;
  }
}

.collapse-custom {
  justify-content: end;
}

.top-row {
  width: 100%;
  background: #28af4b;
  /* display: flex; */
  color: #ffffff;
  /* justify-content: space-around; */
  /* top: 0; */
  /* z-index: 8; */
}

.loc-container-drop {
  align-items: center;
  flex-direction: row;
  position: relative;
  display: inline-block;
  display: flex;
  height: 100%;
}

.loc-icon {
  width: 20px;
  height: 20px;
}

.nav-text {
  font-family: Manrope;
  font-weight: bold;
  color: #333132;
}

.nav-items-custom {
  --bs-navbar-active-color: #28af4b;
  --bs-navbar-hover-color: #28af4b;
}

/* .searchIcon{
  marginLeft:"-2rem";
  width:7%
} */
.bulletless-list {
  list-style-type: none;
  padding: 10px !important;
}

.searcher {
  background-color: #f5f5f5;
  box-shadow: none;
  border: none;
  /* width: 300px; */
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  appearance: none;
}

.profileNameStyle {
  margin-left: 10%;
  margin-right: 10%;
  text-decoration: none;
  color: #333132;
}

.profileContainer {
  display: flex;
}

.logout-button {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  background-color: none;
}

@media (min-width: 992px) and (max-width: 1110px) {
  .navbar-collapse {
    flex-basis: auto;
  }

  .navbar-nav {
    flex-direction: row;
    justify-content: flex-end;
  }

  .navbar-nav .nav-item:last-child {
    margin-right: 10px;
  }

  .profileContainer {
    margin-right: 10px;
  }
}

/* .cart-container {
  position: relative;
  display: inline-block;
}

.cart-icon {
  width: 40px; 
  height: auto;
}



.badge {
  position: absolute;
  top: -5px;
  right: -5px; 
  min-width: 20px; 
  height: 20px; 
  border-radius: 50%; 
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: red; 
  color: white;
  font-size: 12px; 
  font-weight: bold; 
  z-index: 1; 
} */

@media (max-width: 991px) {
  .navhead {
    .container-fluid {
      width: 90%;
    }
  }

  .container-fluid {
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .navbar-toggler:hover {
    text-decoration: none;
    /* margin-right: 33px; */
    /* margin-top: 8px; */
  }

  .navhead {
    display: flex;
    /* padding-top: 3rem; */
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-self: start;
  }
}

@media (max-width: 600px) {
  .header-re-style {
    font-size: 12px;
  }
}

.header-style {
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100%;
}

.navbaractive {
  color: #28af4b !important;
}

.nav-text:hover {
  color: #28af4b !important;
}

.span-content {
  justify-content: center;
  align-items: center;
  max-width: 125px;
  width: 100%;
}

.nav-dropdown-style {
  --bs-dropdown-link-active-bg: none;
  --bs-dropdown-link-active-color: #28af4b;
}

.dropdown-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.list-div-search {
  position: absolute;
  top: 100%;
  max-height: 150px;
  overflow-y: auto;
  background-color: white;
  padding: 0;
}

.badge-custom {
  position: absolute;
  top: 0;
  left: 70%;
  border-radius: 50%;
  background-color: #28af4b;
}

.badge-position {
  position: relative;
}

.img-wrapper {
  position: relative;
  display: inline-block;
}

.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.location-span {
  font-family: Manrope;
  font-weight: 400;
  color: #333132;
}

.location-span:hover {
  color: #28af4b !important;
}

.header-logo {
  min-width: 80px;
}

/* 
.cart-animation {
  animation: animateBall 2.6s infinite;
} */

/* @keyframes animateBall {
  0%,
  100% {
    transform: translateX(-6.5%);
  }
  20% {
    transform: translateX(0%);
  }
  25% {
    transform: translateX(-1%);
  }
  40% {
    transform: translateX(11%);
  }
  55% {
    transform: translateX(-11%);
  }
  60% {
    transform: translateX(0%);
  }
  68% {
    transform: translateX(10%);
  }
  78% {
    transform: translateX(-11%);
  }
  90% {
    transform: translateX(11%);
  }
  98% {
    transform: translateX(-11%);
  }
} */

.product-img-pop {
  width: 45px;
}

.bottom-border-active {
  height: 3px;
  background-color: #28af4b;
  width: 100%;
  position: absolute;
  bottom: -20px;
  left: 0;
}

@media (max-width: 992px) {
  .bottom-border-active {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,kEAAkE;EAClE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;;GAGG;AACH;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;EACE;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  background-color: #ffffff;\n  display: flex;\n  font-family: Manrope;\n}\n\n.navhead {\n  background-color: #ffffff !important;\n  box-shadow: #0000001a 0px 5px 7px -3px, #0000000d 0px 2px 3px -2px;\n  width: 100%;\n  min-height: 80px;\n}\n\n.navhead {\n  .container-fluid {\n    width: 90%;\n  }\n}\n\n.collapse-custom {\n  justify-content: end;\n}\n\n.top-row {\n  width: 100%;\n  background: #28af4b;\n  /* display: flex; */\n  color: #ffffff;\n  /* justify-content: space-around; */\n  /* top: 0; */\n  /* z-index: 8; */\n}\n\n.loc-container-drop {\n  align-items: center;\n  flex-direction: row;\n  position: relative;\n  display: inline-block;\n  display: flex;\n  height: 100%;\n}\n\n.loc-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.nav-text {\n  font-family: Manrope;\n  font-weight: bold;\n  color: #333132;\n}\n\n.nav-items-custom {\n  --bs-navbar-active-color: #28af4b;\n  --bs-navbar-hover-color: #28af4b;\n}\n\n/* .searchIcon{\n  marginLeft:\"-2rem\";\n  width:7%\n} */\n.bulletless-list {\n  list-style-type: none;\n  padding: 10px !important;\n}\n\n.searcher {\n  background-color: #f5f5f5;\n  box-shadow: none;\n  border: none;\n  /* width: 300px; */\n}\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.profileNameStyle {\n  margin-left: 10%;\n  margin-right: 10%;\n  text-decoration: none;\n  color: #333132;\n}\n\n.profileContainer {\n  display: flex;\n}\n\n.logout-button {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline;\n  cursor: pointer;\n  text-decoration: none;\n  color: inherit;\n  background-color: none;\n}\n\n@media (min-width: 992px) and (max-width: 1110px) {\n  .navbar-collapse {\n    flex-basis: auto;\n  }\n\n  .navbar-nav {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  .navbar-nav .nav-item:last-child {\n    margin-right: 10px;\n  }\n\n  .profileContainer {\n    margin-right: 10px;\n  }\n}\n\n/* .cart-container {\n  position: relative;\n  display: inline-block;\n}\n\n.cart-icon {\n  width: 40px; \n  height: auto;\n}\n\n\n\n.badge {\n  position: absolute;\n  top: -5px;\n  right: -5px; \n  min-width: 20px; \n  height: 20px; \n  border-radius: 50%; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: red; \n  color: white;\n  font-size: 12px; \n  font-weight: bold; \n  z-index: 1; \n} */\n\n@media (max-width: 991px) {\n  .navhead {\n    .container-fluid {\n      width: 90%;\n    }\n  }\n\n  .container-fluid {\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .navbar-toggler:hover {\n    text-decoration: none;\n    /* margin-right: 33px; */\n    /* margin-top: 8px; */\n  }\n\n  .navhead {\n    display: flex;\n    /* padding-top: 3rem; */\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-self: start;\n  }\n}\n\n@media (max-width: 600px) {\n  .header-re-style {\n    font-size: 12px;\n  }\n}\n\n.header-style {\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  width: 100%;\n}\n\n.navbaractive {\n  color: #28af4b !important;\n}\n\n.nav-text:hover {\n  color: #28af4b !important;\n}\n\n.span-content {\n  justify-content: center;\n  align-items: center;\n  max-width: 125px;\n  width: 100%;\n}\n\n.nav-dropdown-style {\n  --bs-dropdown-link-active-bg: none;\n  --bs-dropdown-link-active-color: #28af4b;\n}\n\n.dropdown-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.dropdown-item {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f0f0f0;\n}\n\n.list-div-search {\n  position: absolute;\n  top: 100%;\n  max-height: 150px;\n  overflow-y: auto;\n  background-color: white;\n  padding: 0;\n}\n\n.badge-custom {\n  position: absolute;\n  top: 0;\n  left: 70%;\n  border-radius: 50%;\n  background-color: #28af4b;\n}\n\n.badge-position {\n  position: relative;\n}\n\n.img-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.line-clamp {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.location-span {\n  font-family: Manrope;\n  font-weight: 400;\n  color: #333132;\n}\n\n.location-span:hover {\n  color: #28af4b !important;\n}\n\n.header-logo {\n  min-width: 80px;\n}\n\n/* \n.cart-animation {\n  animation: animateBall 2.6s infinite;\n} */\n\n/* @keyframes animateBall {\n  0%,\n  100% {\n    transform: translateX(-6.5%);\n  }\n  20% {\n    transform: translateX(0%);\n  }\n  25% {\n    transform: translateX(-1%);\n  }\n  40% {\n    transform: translateX(11%);\n  }\n  55% {\n    transform: translateX(-11%);\n  }\n  60% {\n    transform: translateX(0%);\n  }\n  68% {\n    transform: translateX(10%);\n  }\n  78% {\n    transform: translateX(-11%);\n  }\n  90% {\n    transform: translateX(11%);\n  }\n  98% {\n    transform: translateX(-11%);\n  }\n} */\n\n.product-img-pop {\n  width: 45px;\n}\n\n.bottom-border-active {\n  height: 3px;\n  background-color: #28af4b;\n  width: 100%;\n  position: absolute;\n  bottom: -20px;\n  left: 0;\n}\n\n@media (max-width: 992px) {\n  .bottom-border-active {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
